import { useEffect, useState } from 'react';

import './dropdown.css';

import { ContextMenu } from '../context-menu/context-menu';
import { Button } from '../button/button';
import { Icon } from '../icon/icon';
import { Widget } from '../widget/widget';
import { Tooltip } from '../tooltip/tooltip';

export function DropDown(props) {
    const [open, setOpen] = useState();

    const value = props.value;
    useEffect(() => {
        setOpen(false);
    }, [value]);

    const showErrorIndicator = (props.mandatory && !props.value) || props.error;
    const className = props.class || "";

    return (
        <div className={`dropdown ${className}`}>
            {props.label &&
                <div className="dropdown-header">
                    <label className="dropdown-label">
                        { props.label }
                        { showErrorIndicator &&
                            <Icon name="ic_asterisk" class="error-indicator" />
                        }
                    </label>
                    { props.tooltip &&
                        <Tooltip text={props.tooltip} position="left">
                            <Icon name="ic_info-fill" class="dropdown-tooltip-icon" />
                        </Tooltip>
                    }
                </div>
            }
            <ContextMenu
                align="left"
                content={props.children}
                open={open}
                closed={() => setOpen(false)}>
                <Button 
                    variant="label" 
                    icon={props.icon}
                    disabled={props.disabled}
                    readonly={props.readonly}
                    loading={props.loading}
                    clicked={() => setOpen(!open)}>
                    {props.value &&
                        props.value
                    }
                    {!props.value &&
                        props.placeholder
                    }
                    <Icon name="ic_arrow_fill-down" />
                </Button>
            </ContextMenu>
            
            { props.error &&
                <Widget variant="alert" class="dropdown-error">
                    <Icon name="ic_alert-outline" class="dropdown-error-icon" />
                    <span>
                        { props.error }
                    </span>
                </Widget>
            }
        </div>
    );
}